var _path, _polygon, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdwayLabsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 364.625 72.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.73,398.316a33.983,33.983,0,0,0-4.618-17.132l-3.787,2.125-7.256,4.073a21.466,21.466,0,0,1,.234,21.461l10.863,6.506h0v0l.013,0-.008-.005A33.986,33.986,0,0,0,191.73,398.316Z",
    transform: "translate(-123.319 -360.32)",
    fill: "#f9e6da"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "54.63 57.148 63.847 55.028 52.984 48.523 52.993 48.528 54.63 57.148",
    fill: "#f9e6da"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.112,381.184a34.219,34.219,0,0,0-29.447-17.07l-.113,12.666a21.545,21.545,0,0,1,18.51,10.591l0,0,.006,0,0,.007.006,0,8.491,3.235Z",
    transform: "translate(-123.319 -360.32)",
    fill: "#f2bc95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.224,370.932l-6.7-6.792v-.029H157.5a34.208,34.208,0,0,0-28.981,16.112l10.868,6.509a21.533,21.533,0,0,1,18.142-9.953v-.1Z",
    transform: "translate(-123.319 -360.32)",
    fill: "#eb8e52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.949,417.468l-1.637-8.619-.009-.006a21.527,21.527,0,1,1-36.92-22.111l-1.633-8.626-9.235,2.117a34.19,34.19,0,1,0,58.653,35.127h0Z",
    transform: "translate(-123.319 -360.32)",
    fill: "#e36e26"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TEXT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.076,380.385a30.344,30.344,0,0,0-11.879-12.33c-4.891-2.751-11.529-4.146-19.732-4.146H260.929v13.632H270.6a60.392,60.392,0,0,1,8.151.3,18.56,18.56,0,0,1,4.976,1.786,17.657,17.657,0,0,1,4.622,3.415c3.665,3.729,5.445,8.456,5.445,14.452,0,6.159-1.752,11.089-5.339,15.055a17.339,17.339,0,0,1-3.627,3.017,19.08,19.08,0,0,1-5.035,2.047,36.629,36.629,0,0,1-8.945.833H260.96v13.48h9.315a73.933,73.933,0,0,0,10.769-.5,29.485,29.485,0,0,0,6.469-2.006,30.17,30.17,0,0,0,10.622-7.381,33.455,33.455,0,0,0,6.9-10.983,36.009,36.009,0,0,0,2.414-13.063A36.541,36.541,0,0,0,303.076,380.385Z",
    transform: "translate(-123.319 -360.32)",
    fill: "#e16e2e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.407 3.521 244.174 37.431 227.985 0 221.673 16.033 213.408 37.263 199.577 3.521 185.665 3.521 213.339 71.602 228.28 33.609 244.204 71.498 269.49 7.256 270.741 3.521 257.407 3.521",
    fill: "#e16e2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.516,363.909l-14.951,20.4-14.716-20.4H425.783l2.882,4.337c1.465,2.2,17.872,24.634,21.162,29.131v34.545h13.56V397.544c6.915-9.706,19.5-27.319,20.933-29.1l3.624-4.531Z",
    transform: "translate(-123.319 -360.32)",
    fill: "#e16e2e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.541 3.556 277.649 21.403 286.087 41.104 270.037 41.104 265.162 53.707 291.484 53.707 299.15 71.602 313.009 71.602 284.541 3.556",
    fill: "#e16e2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.554,431.922l-12.371-19.977a27.437,27.437,0,0,0,9.264-20.766,29.165,29.165,0,0,0-6.126-18.281c-4.645-5.776-11.333-8.884-19.378-8.989H199.4v68.013H211.87V377.18l9.625-.036c4.62.06,13.644,2.025,13.644,14.035,0,11.7-11.955,15.471-12.072,15.535l-.1-.159,1.415,2.571-.008,0,.093.151,12.47,22.641Z",
    transform: "translate(-123.319 -360.32)",
    fill: "#e36e26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdwayLabsLogo);
export default __webpack_public_path__ + "static/media/ordway-labs-logo.a2fd47fc301010ac7d6973df736cb3b7.svg";
export { ForwardRef as ReactComponent };